/** @file Layout equality for recompile's fast path: identity by kind, packed by atlas object. */
import type { TextureLayout } from '../textureLayout';

/** True when both layouts produce the same pages: both identity, or both packed with the same atlas object. */
export function sameLayout(a: TextureLayout, b: TextureLayout): boolean {
  if (a.kind === 'identity') return b.kind === 'identity';
  return b.kind === 'packed' && a.atlas === b.atlas;
}
